import React from 'react';

import { sendErrorEvent } from '@trello/error-reporting';
import ReactDOM from '@trello/react-dom-wrapper';

import { renderComponent } from 'app/src/components/ComponentWrapper';
import { WorkspacesAutoNameAlert } from 'app/src/components/WorkspacesAutoNameAlert';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unmountWorkspacesAutoNameAlert = function (this: any) {
  if (this.workspacesAutoNameAlertTarget) {
    ReactDOM.unmountComponentAtNode(this.workspacesAutoNameAlertTarget);
    this.workspacesAutoNameAlertTarget = null;
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderWorkspacesAutoNameAlert = function (this: any) {
  if (!this.workspacesAutoNameAlertTarget) {
    this.workspacesAutoNameAlertTarget = this.el.querySelector(
      '#workspaces-auto-name-alert',
    );

    if (this.workspacesAutoNameAlertTarget) {
      try {
        renderComponent(
          <WorkspacesAutoNameAlert orgId={this.model.get('idOrganization')} />,
          this.workspacesAutoNameAlertTarget,
        );
      } catch (err) {
        sendErrorEvent(err, {
          tags: {
            ownershipArea: 'trello-mocha',
            feature: 'Workspaces Auto Name Alert',
          },
          extraData: {
            component: 'board-view-collaboration',
          },
        });
      }
    }
  }
};
